export const calendar = {
  today: 'Sekarang',
  later: 'Kemudian',
  shortDays: ['M', 'S', 'S', 'R', 'K', 'J', 'S'],
  longDays: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu'],
  months: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
};
